/** @jsxImportSource @emotion/react */

import { cx } from '@emotion/css';

type Props = React.ComponentProps<'label'> & {
  /** Use when this is a section heading */
  heading?: boolean;
};

const ODSLabel: React.FC<Props> = ({
  className,
  heading,
  children,
  htmlFor,
  ...componentProps
}) => (
  <label
    {...(!!htmlFor && { htmlFor })}
    className={cx('user-select-none', className, {
      'text-secondary small': !heading,
      'little-heading': heading,
    })}
    {...componentProps}
  >
    {children}
  </label>
);

export default ODSLabel;
